export default from './post-header';



// WEBPACK FOOTER //
// ./app/components/post-header/index.js